import React, { Suspense, useState } from "react";
// import DatePicker from "react-datepicker";
import { useLangContext } from "@assets/spa/context/lang";
import lt from "date-fns/locale/lt";
import { LoadingBox } from "@assets/tsx/loadingBox/loadingBox";
const DatePicker = React.lazy(() => import("react-datepicker"));
export function ForminatorDate(props) {
    const [startDate, setStartDate] = useState();
    const [lang] = useLangContext();
    let format = props.date_format || 'yy-mm-dd';
    format = format.replace('yy', 'yyyy').replace('mm', 'MM');
    return (React.createElement(Suspense, { fallback: React.createElement(LoadingBox, { style: { minHeight: 70 } }) },
        React.createElement(DatePicker, { selected: startDate, locale: lang === "lt" ? lt : undefined, dateFormat: format, wrapperClassName: 'd-block', onChange: (date) => {
                setStartDate(date);
                if (!date) {
                    props.onChange(undefined);
                    return;
                }
                const year = date.getFullYear();
                const month = date.getMonth() + 1;
                const day = date.getDate();
                const dateVal = format.replace('yyyy', year).replace('MM', month).replace('dd', day);
                props.onChange(dateVal);
            }, calendarStartDay: lang === 'lt' ? 1 : undefined, className: 'ltg-control', showIcon: true })));
}
